<template>
  <div class="ochart" v-loading="isLoading">
    <div class="export-btn" @click="exportImg">Export</div>
    <div class="hied-btn">
      输入框:
      <el-radio-group v-model="radio" size="small">
        <el-radio-button label="展示"></el-radio-button>
        <el-radio-button label="隐藏"></el-radio-button>
      </el-radio-group>
    </div>
    <el-button size="mini" class="kpi-btn" @click="insertKPI">提交kpi</el-button>
    <OrgChart
      :data="chartData"
      :vue="Vue"
      :html-to-canvas="html2canvas"
      ref="OrgChart"
      node-id="_id"
      container-class="orgchart-container"
      chart-class="departmentOchart-chart"
      common-class="fa"
      spinner-class="fa fa-circle-o-notch fa-spin spinner"
      left-arrow-class="fa-chevron-left"
      right-arrow-class="fa-chevron-right"
      up-arrow-class="fa-chevron-up"
      down-arrow-class="fa-chevron-down"
      toggle-btn-on-class="fa-plus-square"
      toggle-btn-off-class="fa-minus-square"
      parent-node-symbol-class
      :zoom="false"
      :style="`transform:scale(${slider / 100}) translate(${translate},${translate});width:${scale};height:${scale};`"
      @drag="updateDataOnDrag"
    >
      <div slot-scope="{ nodeData }">
        <div
          v-if="nodeData.类型 === '部门'"
          id="orgdepartment"
          class="title orgdepartment-across"
          style="overflow:unset"
        >
          <span>
            {{ nodeData.名称 }} <span v-if="nodeData.高管">（{{ nodeData.高管 }}）</span>
            <span v-else-if="nodeData.A角">（{{ nodeData.A角 }}）</span>
          </span>
          <div class="depnumber">{{ getRadishNumberOfDepartment(nodeData) }}</div>
          <el-dropdown class="orgdropdown">
            <span class="el-dropdown-link"> <i class="el-icon-setting" style="color:#fff"></i> </span>
            <el-dropdown-menu ref="dropdown" slot="dropdown">
              <el-dropdown-item v-if="couldDelete(nodeData)" @click.native="deleteDepartment(nodeData)"
                >删除该组别</el-dropdown-item
              >
              <el-dropdown-item @click.native="updateDepartmentName(nodeData)"
                >修改{{ getBtnText(nodeData) }}名称</el-dropdown-item
              >
              <el-dropdown-item @click.native="insertDepartment(nodeData, 'down')">新建组别</el-dropdown-item>
              <el-dropdown-item @click.native="showRadishInsert(nodeData)">添加人员</el-dropdown-item>
              <el-dropdown-item @click.native="showMemberList(nodeData)"
                >显示{{ getBtnText(nodeData) }}人员列表</el-dropdown-item
              >
              <el-dropdown-item @click.native="setMemberCharacter(nodeData)">设置AB角</el-dropdown-item>
              <el-dropdown-item v-if="nodeData.isDepartment" @click.native="mergeDepartment(nodeData)"
                >部门查重合并</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div
          v-else-if="nodeData.类型 === '输入'"
          id="ochart-input-box"
          :class="[inputBox === nodeData._id ? 'wide-box' : 'narrow-box', 'title']"
        >
          <el-input
            v-model="nodeData.名称"
            @keyup.enter.native="addTempNewDepartment(nodeData)"
            size="mini"
            @focus="inputBox = nodeData._id"
            @blur="inputBox = ''"
          ></el-input>
        </div>
        <div
          v-else
          id="memberbox"
          :class="[nodeData.members && nodeData.members.length > 30 ? 'widebox' : 'narrowbox', 'title']"
          @mouseup="event => moveRadish(event, nodeData)"
        >
          <span
            style="position:relative;"
            v-for="item in nodeData.members"
            :key="item._id"
            :class="[item.isLeader ? 'leaderradish' : '', 'alpha-tag mr5 md5']"
            @dblclick="_showRadishDetail(item)"
            @mouseup="event => drop(event, item, nodeData)"
            @mousedown="event => drag(event, item, nodeData)"
          >
            {{ item.姓名 }} <span v-if="item.专业职级">（{{ item.专业职级 }}）</span>
            <div class="redradius" v-if="item.A角"></div>
            <span v-if="!item.手机 && !hideInput" style="line-height: 14px;" class="cc-icon">c</span>
            <i class="el-icon-star-on" @click="_showscore(item)"></i>
          </span>
          <span
            style="position:relative;color: #a9a9a9;"
            v-for="(item, index) in nodeData.temporaryRadish"
            :key="item._id"
            :class="[item.isLeader ? 'leaderradish' : '', 'alpha-tag info mr5 md5']"
            @dblclick="bindRadish(item, nodeData)"
            @mouseup="event => drop(event, item, nodeData)"
            @mousedown="event => drag(event, item, nodeData)"
          >
            {{ item.姓名 }} <i class="el-icon-star-on" @click="_showscore(item, 'temporary')"></i>
            <i class="el-icon-circle-close" @click="deleteTemporary(nodeData, item, index)" style="margin-left:5px"></i>
          </span>
          <el-input
            v-model="tempRadishName[nodeData._id]"
            @keyup.enter.native="addTempNewRadish(nodeData)"
            size="mini"
            v-if="!hideInput"
          ></el-input>
        </div>
      </div>
    </OrgChart>
    <!-- 添加人选 -->
    <div class="insertradish" v-if="showInsertRadish">
      <div class="componentclose" @click="showInsertRadish = false">X</div>
      <radishSimpleAdd
        ref="radishSimpleAdd"
        :company="companyName"
        :department="toInsertRadishDepartment.部门"
        :group="toInsertRadishDepartment.组别"
        :onSave="radishSave"
      ></radishSimpleAdd>
    </div>
    <!-- 操作弹窗 -->
    <OchartDialog
      ref="OchartDialog"
      :btnText="getBtnText(updateNameDepa)"
      @cancel="cancelDialog"
      @confirm="confirmDialog"
    ></OchartDialog>
    <!-- 绑定人选弹窗 -->
    <serch-radish-dialog ref="serchRadishDialog" chooseBtnText="绑定" :couldInsert="true" @choose="toBindThisRadish">
    </serch-radish-dialog>
    <!-- 设置部门角色弹窗 -->
    <OchartCharacter ref="OchartCharacter" @refreshTable="loadData"></OchartCharacter>
  </div>
</template>
<script>
const shortid = require('shortid')
import OchartDialog from '../ochartDialog/OchartDialog'
import serchRadishDialog from '../component/serchRadishDialog.vue'
import OchartCharacter from '../ochartDialog/OchartCharacter'
import { 专业职级排序 } from '../../statistics/variant/fixedvariant'

import createWalk from 'tree-walk'
import OrgChart from '@c42/vue-orgchart'
import Vue from 'vue'
import html2canvas from 'html2canvas'

const walk = createWalk(node => node.children)
const addShortId = data => {
  if (!data._id) {
    data._id = shortid.generate()
  }
  return data
}

export default {
  components: { OchartDialog, OrgChart, serchRadishDialog, OchartCharacter },
  props: {
    slider: { type: Number, default: 100 },
    //  hideInput: { type: Boolean, default: false }
  },
  data() {
    return {
      Vue,
      html2canvas,
      chartData: {
        _id: 1,
        名称: '无',
        children: [],
      },
      isLoading: false,
      departmentName: '',
      companyName: '',
      ochartDragingItem: {
        childItem: {},
        oldParentItem: {},
        newParentItem: {},
      },
      tempRadishName: {},
      readyToBind: {},
      showInsertRadish: false,
      toInsertRadishDepartment: '',
      inputBox: '',
      updateNameDepa: {},
      addRadishDepartment: '',
      radio: '展示',
      hideInput: false,
    }
  },
  computed: {
    scale: function() {
      return 10000 / this.slider.toFixed(3) + '%'
    },
    translate: function() {
      let num = this.scale.replace('%', '')
      num = ((num - 100) / 2).toFixed(3) + '%'
      return '-' + num
    },
  },
  watch: {
    // hideInput(newValue, oldValue) {
    //   this.toTreeData(this.ochartDataItems)
    // },
    radio(newValue, oldValue) {
      this.hideInput = newValue === '隐藏'
      this.toTreeData(this.ochartDataItems)
    },
  },
  mounted() {
    this.$nextTick(_ => {
      const exportBtn = this.$refs.OrgChart && this.$refs.OrgChart.$el.querySelector('.oc-export-btn')
      exportBtn && (exportBtn.style.display = 'none')
    })
  },
  methods: {
    exportImg() {
      this.$nextTick(_ => {
        const exportBtn = this.$refs.OrgChart.$el.querySelector('.oc-export-btn')
        exportBtn && exportBtn.click()
      })
    },
    addRadishInputFocus() {
      this.$nextTick(_ => {
        const dom = this.$el.querySelector(`#${this.addRadishDepartment} input`)
        dom.focus()
        this.addRadishDepartment = ''
      })
    },
    async deleteTemporary(nodeData, radish, index) {
      this.$alert(`确定删除该临时人选吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          const res = await app.service('company').deleteTemporarPerson({ did: nodeData.pid, rid: radish._id })
          if (res.status === 'success') {
            const department = this.findNodeById(nodeData.pid)
            if (!department.temporaryRadish) department.temporaryRadish = []
            department.temporaryRadish.splice(index, 1)
          }
          this.$message.success('删除成功!')
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    getBtnText(nodeData) {
      if (nodeData) return nodeData.isDepartment ? '部门' : '组别'
    },
    findNodeById(nodeId) {
      return walk.find(this.chartData, node => node._id === nodeId)
    },
    findParentNodeById(nodeId) {
      return walk.find(this.chartData, node => node.children && node.children.some(child => child._id === nodeId))
    },
    initOchartPosition() {
      const dom = this.$el.querySelector('.departmentOchart-chart')
      if (dom) dom.style.transform = 'matrix(1, 0, 0, 1, 0, 0)'
    },
    cancelDialog(dialogType) {
      if (dialogType === '人2人') {
        this.dragRadish = ''
        this.dropRadish = ''
      } else if (dialogType === '改名') {
        this.updateNameDepa = ''
      }
    },
    confirmDialog({ result, dialogType, departmentPosition }) {
      if (dialogType === '部2部') this.confirmDragDepartment(result)
      // else if (dialogType === '人2人') this.confirmDragRadish(result)
      else if (dialogType === '人2部') this.confirmChooseCharacter(result)
      else if (dialogType === '改名') this.confirmUpdateDepa(result)
      else if (dialogType === '高管') this.confirmSetCeo(result)
      else if (dialogType === '合并部门') this.confirmMergeDepartment(result)
      else this.confirmCreateDepa(result)
    },
    openDialog(type, params) {
      this.$emit('modifyZIndex')
      this.$refs.OchartDialog.open(type, params)
    },
    async addTempNewRadish(nodeData) {
      if (!nodeData.temporaryRadish) nodeData.temporaryRadish = []
      const res = await app
        .service('company')
        .insertTemporaryPerson({ did: nodeData.pid, name: this.tempRadishName[nodeData._id] })
      if (res.status === 'success') {
        const department = this.findNodeById(nodeData.pid)
        if (!department.temporaryRadish) department.temporaryRadish = []
        department.temporaryRadish.push(res.data)
        nodeData.temporaryRadish.push(res.data)
      }
      this.tempRadishName[nodeData._id] = ''
      this.addRadishDepartment = nodeData._id
      this.addRadishInputFocus()
    },
    async addTempNewDepartment(nodeData) {
      const newDepartment = {
        名称: nodeData.名称,
        parentId: nodeData.pid,
        部门: nodeData.部门,
        公司: nodeData.公司,
        isDepartment: false,
        组别: nodeData.组别 ? `${nodeData.组别}**${nodeData.名称}` : nodeData.名称,
      }
      const res = await app.service('company').insertDepartment(newDepartment)
      if (res.status === 'success') {
        // TODO: 修改为不重新拉数据
        this.loadData()
      }
      // newDepartment.children = [this.getMemberBox(newDepartment)]
      // addShortId(newDepartment)
      // const parent = this.findParentNodeById(nodeData._id)
      // parent.children.splice(parent.children.length - 1, 0, newDepartment)
      // this.ochartDataItems.push(newDepartment)
      // nodeData.label = ''
    },
    async insertOchartTable(radish, department, character) {
      let result = await app.service('company').insertOchartTable({
        department: department,
        radish: radish,
        character: character,
      })
      if (result.status === 'success') {
        this.loadData()
      } else this.$message(result.msg)
    },
    async confirmChooseCharacter(result) {
      let character = result
      let radish = this.ochartDragingItem.childItem
      let department = this.ochartDragingItem.newParentItem
      if (character === 'A角' && department.A角) {
        this.$alert(`该部门已存在A角（${department.A角}），是否替换`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then(async () => {
            this.insertOchartTable(radish, department, character)
            this.$message.success('替换成功!')
          })
          .catch(() => {
            this.$message.info('已取消')
          })
      } else if (!character) {
        await app.service('radish').modifyById({ _id: radish._id, data: { 组别: department.组别 } })
        this.loadData()
      } else if (character === '无') {
        await app.service('company').deleteOchartTable({ department, radish })
        this.loadData()
      } else {
        this.insertOchartTable(radish, department, character)
      }
    },
    getRadishNumberOfDepartment(department) {
      if (!department.members) department.members = []
      if (!department.temporaryRadish) department.temporaryRadish = []
      return department.members.length + department.temporaryRadish.length
    },
    couldDelete(department) {
      const num = this.getRadishNumberOfDepartment(department)
      return !department.isDepartment && num === 0
    },
    async deleteDepartment(nodeData) {
      const res = await app.service('company').deleteDepartment(nodeData)
      if (res.status == 'success') this.loadData()
      else this.$message.error(res.msg)
    },
    getDragingItems({ targetId, sourceId, destinationId }) {
      this.ochartDataItems.forEach(val => {
        // 被拖拽部门
        if (val._id === targetId) this.ochartDragingItem.childItem = val
        // 被拖拽部门的原父元素
        if (val._id === sourceId) this.ochartDragingItem.oldParentItem = val
        // 被拖拽部门的新父元素
        if (val._id === destinationId) this.ochartDragingItem.newParentItem = val
      })
    },
    async updateDataOnDrag(params) {
      // {targetId: "_id", sourceId: "oldparentId", destinationId: "newparentId"}
      this.getDragingItems(params)

      const { childItem, newParentItem } = this.ochartDragingItem
      this.toTreeData(this.ochartDataItems)
      const flag = childItem && newParentItem && childItem.类型 === '部门' && newParentItem.类型 === '部门'
      if (flag) this.openDialog('部2部', [childItem, newParentItem])
    },
    async loadData(params, isRefresh) {
      if (params) {
        this.companyName = params.companyName
        this.departmentName = params.departmentName
      }
      const res = await app
        .service('company')
        .getDepartmentOchart({ 公司: this.companyName, 部门: this.departmentName })
      if (res.status === 'success') {
        if (res.data.length !== 0) {
          this.$emit('loadDataEnd')
          this.ochartDataItems = res.data
          this.toTreeData(res.data)
          if (isRefresh) this.$message.success('刷新成功')
        } else {
          this.$message.error('未获取到数据，请在测试小队描述此bug')
        }
      }
    },
    getMemberBox(department) {
      const { members = [], temporaryRadish = [] } = department
      const box = {
        类型: 'members',
        pid: department._id,
        公司: department.公司,
        部门: department.部门,
        组别: department.组别,
        members,
        temporaryRadish,
        _id: `${department._id}-memberbox`,
      }
      return box
    },
    departmentTemplate(department) {
      const inputBox = {
        名称: '',
        部门: department.部门,
        公司: department.公司,
        组别: department.组别,
        pid: department._id,
        isDepartment: false,
        类型: '输入',
      }
      return addShortId(inputBox)
    },
    initDepartment(department) {
      if (department.inited) return department
      department.类型 = '部门'
      department.pid = department.parentId
      const table = department.table || []
      const A = table.find(val => val.部门角色 === 'A角')
      const AArr = []
      const BArr = []
      const ordinaryArr = []
      department.members.forEach((radish, index) => {
        radish.sort = 专业职级排序[radish.专业职级] || 100
        const res = table.find(val => val.rid === radish._id)
        if (res) {
          radish.isLeader = true
          if (res.部门角色 === 'A角') {
            radish.A角 = true
            AArr.push(radish)
          } else BArr.push(radish)
        } else ordinaryArr.push(radish)
      })
      // 专业职级排序
      ordinaryArr.sort((a, b) => a.sort - b.sort)
      // 展示按A角B角和普通排序
      department.members = AArr.concat(BArr.concat(ordinaryArr))
      department.A角 = A ? A.姓名 || A.人选 : null
      department.inited = true
      return department
    },
    toTreeData(originalArr) {
      const arr = JSON.parse(JSON.stringify(originalArr))
      let tree = []
      let pos = {}
      let i = 0
      let num = 0
      const val = arr.map(this.initDepartment)
      while (num < 10000 && val.length !== 0) {
        num++
        // const department = val[i].inited ? this.initDepartment(val[i]) : val[i]
        const department = val[i]
        // department.类型 = '部门'
        // department.pid = department.parentId
        if (department.isDepartment) {
          department.children = [this.getMemberBox(department)]
          if (!this.hideInput) department.children.push(this.departmentTemplate(department))
          tree.push(department)
          pos[department._id] = [0]
          val.splice(i, 1)
          i = -1
        } else {
          let posArr = pos[department.pid]
          if (posArr) {
            let obj = tree[posArr[0]]
            if (!obj.children) obj.children = this.hideInput ? [] : [this.departmentTemplate(department)]
            for (let ind = 1; ind < posArr.length; ind++) {
              obj = obj.children[posArr[ind]]
              if (!obj.children) obj.children = this.hideInput ? [] : [this.departmentTemplate(department)]
            }
            department.children = [this.getMemberBox(department)]
            if (!this.hideInput) department.children.push(this.departmentTemplate(department))
            obj.children.splice(this.hideInput ? obj.children.length : obj.children.length - 1, 0, department)
            pos[department._id] = posArr.concat([this.hideInput ? obj.children.length - 1 : obj.children.length - 2])
            val.splice(i, 1)
            i = -1
          }
        }
        i++
        if (i > val.length - 1) i = 0
      }
      this.initOchartPosition()
      this.chartData = tree[0] || {}
      this.addDrop()
    },
    addDrop() {
      this.$nextTick(() => {
        this.ochartDataItems.map(item => {
          let dom = this.$el.querySelector(`#${item._id}`)
          if (!dom) return
          let str = dom.getAttribute('data-source')
          let data = JSON.parse(str)
          dom.onmouseup = null
          dom.onmouseup = e => {
            e.stopPropagation()
            this.changeDepartment(data)
          }
        })
      })
    },
    drag(event, data, nodeData) {
      event.preventDefault()
      event.stopPropagation()
      data.pid = nodeData.pid
      this.ochartDragingItem.childItem = data
      this.dragRadish = data
      this.targetRadishDom = event.target
      event.target.style.color = '#f56005'
      this.radishIsDraging = true
      this.documentMouseUp()
    },
    documentMouseUp() {
      const documentMouseUp = event => {
        if (this.targetRadishDom) this.targetRadishDom.style.color = ''
        document.removeEventListener('mouseup', documentMouseUp)
        this.radishIsDraging = false
      }
      document.addEventListener('mouseup', documentMouseUp)
    },
    drop(event, data, nodeData) {
      if (this.radishIsDraging) {
        event.preventDefault()
        event.stopPropagation()
        this.radishIsDraging = false
        this.targetRadishDom.style.color = ''
        // let child = this.ochartDragingItem.childItem
        // let parent = data
        // if (child._id !== parent._id) {
        //   if (parent.A角 || child.A角) {
        //     this.$message(`${child.A角 ? child.姓名 : parent.姓名}为该部门A角，无法与人选互动`)
        //     this.radishIsDraging = false
        //     this.targetRadishDom.style.color = ''
        //   } else {
        //     this.ochartDragingItem.newParentItem = parent
        //     this.dropRadish = parent
        //     this.dropRadishDepartment = nodeData
        //     this.openDialog('人2人', [this.dragRadish, this.dropRadish])
        //   }
        // } else {
        //   this.radishIsDraging = false
        //   this.targetRadishDom.style.color = ''
        // }
      }
    },
    changeDepartment(department) {
      const radish = this.ochartDragingItem.childItem
      if (!radish) return
      if (!this.radishIsDraging) return
      if (radish.isTemporary) {
        this.radishIsDraging = false
        this.targetRadishDom.style.color = ''
      } else {
        this.openDialog('人2部')
        this.ochartDragingItem.newParentItem = department
      }
    },
    _showscore(val, type) {
      app.root.$refs.radishScore.open(val._id || val.rid, type, val.姓名)
    },
    async moveRadish(event, nodeData) {
      event.preventDefault()
      event.stopPropagation()
      if (!this.radishIsDraging) return
      let child = this.ochartDragingItem.childItem
      let parent = nodeData
      await this.toMoveRadish(child, parent)
      this.radishIsDraging = false
      this.targetRadishDom.style.color = ''
      // TODO:修改为不要重新拉数据
      this.loadData()
    },
    bindRadish(item, nodeData) {
      const radish = { 公司: nodeData.公司, 部门: nodeData.部门, 组别: nodeData.组别, 姓名: item.姓名 }
      this.readyToBind = { radish: item, nodeData }
      this.$refs['serchRadishDialog'].open(radish)
    },
    async toBindThisRadish(radish) {
      // TODO:绑定之后修改前后端数据，暂时改为重新拉数据
      const oldData = this.readyToBind.radish
      const res = await app
        .service('company')
        .ochartBindRadish({ temporaryRadish: this.readyToBind.radish, radish, nodeData: this.readyToBind.nodeData })
      this.loadData()
    },
    _showRadishDetail(val) {
      window.open(`${window.frontend}/#/radish-detail-blank/${val._id}`, '_blank')
    },
    updateDepartmentName(nodeData) {
      this.updateNameDepa = nodeData
      this.openDialog('改名')
    },
    async confirmUpdateDepa(result) {
      const res = await app.service('company').updateDepartmentName({
        _id: this.updateNameDepa._id,
        newName: result,
      })
      if (res.status === 'success') {
        if (this.updateNameDepa.isDepartment) this.departmentName = result
        this.loadData()
      }
    },
    insertDepartment(nodeData) {
      this.openDialog('添加部门')
      this.parentDepartment = nodeData
    },
    async confirmCreateDepa(result) {
      if (!result) return this.$message.warning('请输入内容')

      const newDepartment = {
        名称: result,
        parentId: this.parentDepartment._id,
        部门: this.parentDepartment.部门,
        公司: this.parentDepartment.公司,
        isDepartment: false,
        组别: this.parentDepartment.组别 ? `${this.parentDepartment.组别}**${result}` : result,
      }
      const res = await app.service('company').insertDepartment(newDepartment)
      if (res.status === 'success') {
        // TODO: 修改为不重新拉数据
        this.loadData()
      }
    },
    showRadishInsert(nodeData) {
      this.showInsertRadish = true
      this.toInsertRadishDepartment = nodeData
    },
    async radishSave(val) {
      // TODO:改为不重新拉取数据
      if (val.status == 'success') this.loadData()
      this.showInsertRadish = false
    },
    showMemberList(nodeData) {
      const option = { company: nodeData.公司, department: nodeData.部门 }
      if (!nodeData.isDepartment) option.group = nodeData.组别
      app.root.$refs.companyTwoThird.open(option)
    },
    setMemberCharacter(nodeData) {
      this.$refs.OchartCharacter.open(nodeData)
    },
    mergeDepartment(nodeData) {
      this.openDialog('合并部门', nodeData)
    },
    async confirmMergeDepartment(second) {
      const res = await app.service('company').mergeDepartment({ first: this.chartData._id, second: [second._id] })
      if (res.status == 'success') {
        this.$message('合并成功')
        this.loadData()
      }
    },
    async toMoveRadish(radish, department) {
      if (radish.isTemporary) {
        const res = await app.service('company').moveTemporaryPerson({
          radish: radish,
          oldDepartment: radish.pid,
          newDepartment: department.pid,
        })
      } else {
        const res = await app.service('radish').modifyById({ _id: radish._id, data: { 组别: department.组别 || null } })
      }
    },
    // async confirmDragRadish(result) {
    //   let { childItem, newParentItem } = this.ochartDragingItem
    //   const main = childItem._id === result ? childItem : newParentItem
    //   const newName = `${main.姓名}组`
    //   const oldParentDepartment = this.dropRadishDepartment
    //   const newDepartment = {
    //     名称: newName,
    //     parentId: oldParentDepartment.pid,
    //     部门: oldParentDepartment.部门,
    //     公司: oldParentDepartment.公司,
    //     isDepartment: false,
    //     组别: oldParentDepartment.组别 ? `${oldParentDepartment.组别}**${newName}` : newName,
    //   }
    //   const res = await app.service('company').insertDepartment(newDepartment)
    //   const department = res.data
    //   await this.toMoveRadish(childItem, department)
    //   await this.toMoveRadish(newParentItem, department)
    //   this.insertOchartTable(main, department, 'A角')
    //   this.loadData()
    // },
    async confirmDragDepartment(result) {
      let { childItem, newParentItem } = this.ochartDragingItem
      if (result === '平级') {
        if (childItem.isDepartment) return this.$message.error('部门不能移动层级')
        if (newParentItem.isDepartment) return this.$message.error('组别不能和部门变为同一层级')
        await app.service('company').moveDepartment({
          departmentId: childItem._id,
          parentDepartmentId: newParentItem.parentId,
        })
      } else if (result === '下级') {
        if (childItem.isDepartment) return this.$message.error('部门不能移动层级')
        await app.service('company').moveDepartment({
          departmentId: childItem._id,
          parentDepartmentId: newParentItem._id,
        })
      } else if (childItem._id === result) {
        if (childItem.isDepartment || newParentItem.isDepartment) return this.$message.error('部门不能与组别合并')
        await app.service('company').mergeGroup({
          first: childItem._id,
          second: newParentItem._id,
        })
      } else if (newParentItem._id === result) {
        if (childItem.isDepartment || newParentItem.isDepartment) return this.$message.error('部门不能与组别合并')
        await app.service('company').mergeGroup({
          first: newParentItem._id,
          second: childItem._id,
        })
      }
      this.loadData()
    },
    async insertKPI() {
      let result = await app
        .service('company')
        .insertOchartKpi({ user: app.user.account, data: this.chartData, type: '部门' })
      if (result.status === 200) {
        this.$message('保存成功')
      }
    },
  },
}
</script>
<style>
.departmentOchart-chart {
  background-color: #f3f2f2;
  padding-bottom: 20px;
  padding-right: 20px;
}
</style>
<style src="../../statistics/css/departmentOchart.css" scoped></style>
